export default __webpack_public_path__ + "static/media/double_tick.33c56c8b.svg";